const [useProvideParagraphPreview, useParagraphPreviewStore] =
  createInjectionState((initialEnabled: boolean) => {
    const showPreview = ref(initialEnabled);

    const updateShowPreview = (show: boolean) => (showPreview.value = show);

    return {
      showPreview: readonly(showPreview),
      updateShowPreview,
    };
  });

function useParagraphPreview() {
  const store = useParagraphPreviewStore();

  if (!store) {
    throw new Error(
      "useParagraphPreview must be used within a ParagraphPreviewProvider"
    );
  }

  return store;
}

export { useProvideParagraphPreview, useParagraphPreview };
